import React from 'react';

import { CFColorTokenProp } from '../../theme/tokens/contentful-color';

import { AffiliateCta, AffiliateCtaProps } from './AffiliateCta';
import { EmailWidget } from './EmailWidget';
import { WebRegWidget } from './WebRegWidget';

import {
  NonContentfulWidgetProps,
  ctaWidgetEnum,
  PartialCtaProps
} from './shared';

interface CtaWidgetProps extends PartialCtaProps {
  height?: string | number;
  width?: string | number;
  isScrolled?: boolean;
  onStartClick?: () => void;
  cfButtonColor?: CFColorTokenProp;
  cfButtonHoverColor?: CFColorTokenProp;
  module?: string;
  isMobile?: boolean;
}

export default function CtaWidget({
  sysId,
  designType,
  ...props
}: CtaWidgetProps) {
  switch (sysId) {
    case 'emailCta':
      return <EmailWidget {...(props as NonContentfulWidgetProps)} />;

    case 'affiliateCta':
      return <AffiliateCta {...(props as AffiliateCtaProps)} />;

    case 'nonContentfulCta':
    case 'registrationEntrypoint':
    default:
      return (
        <WebRegWidget
          {...props}
          widgetType={designType as ctaWidgetEnum}
          widgetProps={{ ...props }}
          bypassPhoneNumberEntry={
            designType === ctaWidgetEnum.GET_STARTED_NO_PHONE
          }
        />
      );
  }
}
